<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>
      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('henkilonakyma.title', 2) }}</v-toolbar-title>

      <v-spacer/>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col v-if="oikeusKayttajat && oikeusKayttajat.length > 0" cols="12">
              <v-card color="#191919" outlined>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                          v-model="selectedOikeusKayttaja"
                          :item-text="(item) => `${item.firstname} ${item.lastname}`"
                          :items="oikeusKayttajat"
                          :label="$tc('henkilo.select_kayttaja')"
                          clearable
                          return-object
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col>
              <no-content-view v-if="!loading && isEmpty(tehtavat) && isEmpty(vastuualueet)"
                               :title="$t('henkilo.you_have_no_vastuualueita_or_tehtavia')"/>
            </v-col>
            <v-col v-if="vastuualueet && filteredVastuualueet.length > 0" cols="12">
              <v-card color="#191919" outlined>
                <v-card-title>
                  {{ $tc('vastuualue.title', 2) }}
                </v-card-title>
                <v-card-text class="mb-3">
                  <v-row>
                    <vastuualue-box v-for="vastuualue in filteredVastuualueet" :key="vastuualue.id"
                                    :vastuualue="vastuualue"/>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col v-if="tehtavat" cols="12">
              <v-card color="#191919" outlined>
                <v-card-title>
                  {{ $tc('tehtava.title', 2) }}
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="search.text" :label="$t('search')"/>

                      <v-autocomplete v-model="vuosi" :items="vuodet" :label="$t('year')" hide-details
                      ></v-autocomplete>

                    </v-col>
                    <v-col cols="12" md="2">
                      <v-checkbox v-model="search.aloittamatta" :label="$t('tehtava.search.aloittamatta')" dense
                                  hide-details/>
                      <v-checkbox v-model="search.kaynnissa" :label="$t('tehtava.search.kaynnissa')" dense
                                  hide-details/>
                      <v-checkbox v-model="search.valmis" :label="$t('tehtava.search.valmis')" dense hide-details/>
                    </v-col>
                    <v-col cols="7" md="3">
                      <div>
                        <span class="subtitle-1">{{ $t('tehtava.valmisyht') }}</span>
                      </div>
                      <div>
                        {{ $t('tehtava.tehtavia') }}: {{ valmisCount }} / {{ filteredTehtavat.length }}
                      </div>
                      <div>
                        {{ $t('tehtava.painotus') }}: {{ $formatPisteet(painotusCount) }} / {{ painotusYhtCount }}
                      </div>
                    </v-col>
                    <v-col cols="5" md="3">
                      <v-progress-circular :color="$getValmiusprosenttiColor(yht)"
                                           :size="$vuetify.breakpoint.xsOnly ? 80 : 110"
                                           :value="yht"
                                           :width="$vuetify.breakpoint.xsOnly ? 10 : 20">
                                    <span class="text-subtitle-1 text-h6 text-sm-h6">{{
                                        $formatPisteet(yht)
                                      }} %</span>
                      </v-progress-circular>

                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text>
                  <tehtava-table :tehtavat="filteredTehtavat" group-by="_groupBy"/>
                </v-card-text>
              </v-card>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>

import apicollection from "../apicollection";
import VastuualueBox from "../components/Vastuualue/VastuualueBox";
import TehtavaTable from "../components/Tehtava/TehtavaTable";
import orderBy from 'lodash/orderBy'
import NoContentView from "@/components/NoContentView.vue";
import {isEmpty} from "lodash";
import dayjs from "dayjs";

export default {

  name: 'HenkiloView',
  components: {NoContentView, TehtavaTable, VastuualueBox},
  data() {
    return {
      loading: true,
      tehtavat: null,
      vastuualueet: null,
      vuosi: dayjs().year(),
      selectedOikeusKayttaja: null,
    };
  },
  computed: {
    search() {
      return this.$store.state.omatTiedotTehtavaSearch;
    },
    vuodet() {
      return this.$years
    },
    oikeusKayttajat() {
      const otherUsers = [...this.$user?.kayttajanOikeusToiseen?.map(o => o.oikeusUser) || []]
      if (otherUsers.length === 0) {
        return [];
      }
      return [this.$user, ...otherUsers];
    },
    filteredVastuualueet() {
      return this.vastuualueet.filter(v => v.aktiivinen);
    },
    valmisCount() {
      return this.filteredTehtavat.filter(t => t.tila === this.$TEHTAVA_TILA_VALMIS).length
    },
    painotusYhtCount() {
      return this.filteredTehtavat.reduce((c, p) => p.painotus + c, 0);
    },
    painotusCount() {
      return this.filteredTehtavat.reduce((c, p) => p.valmiusPisteet + c, 0);
    },
    filteredTehtavat() {
      let searchStrings = '';
      if (this.search.text) {
        searchStrings = this.search.text.toLowerCase().split(' ');
      }

      let tehtavat = this.tehtavat.filter(t => {
        if (t.tila === this.$TEHTAVA_TILA_ALOITTAMATTA && !this.search.aloittamatta) {
          return false;
        }
        if (t.tila === this.$TEHTAVA_TILA_KAYNNISSA && !this.search.kaynnissa) {
          return false;
        }
        if (t.tila === this.$TEHTAVA_TILA_VALMIS && !this.search.valmis) {
          return false;
        }
        if (this.search.text && this.search.text.length > 0) {
          const tString = [t.otsikko, t.kuvaus, t.vastuuuser && [t.vastuuuser.firstname, t.vastuuuser.lastname].join(' ')]
              .filter(Boolean).join(' ').toLowerCase();
          if (!searchStrings.every(s => tString.includes(s))) {
            return false;
          }
        }
        return true;
      });
      tehtavat.forEach(t => {
        t._groupBy = `${t.vastuualue?.jarjestysnumero}_${t.vastuualueId}`;
      });

      tehtavat = orderBy(tehtavat, ['vastuualue.jarjestysnumero', 'jarjestysnumero'], ['asc', 'desc']);
      return tehtavat;
    },
    yht() {
      return (this.painotusCount / this.painotusYhtCount * 100) || 0
    }
  },
  methods: {
    isEmpty,
    async getUserObjects() {
      this.loading = true;
      try {
        const userObjects = await apicollection.getUserObjects(this.selectedOikeusKayttaja?.id || this.$user.id, this.vuosi);
        this.tehtavat = userObjects.tehtavat;
        this.vastuualueet = userObjects.vastuualueet;
      } catch (e) {
        console.error(e);
        this.$showErrorNotification(this.$t('henkilonakyma.api.get_user_objects_failed'))
      }
      this.loading = false;
    },
  },
  mounted() {
    this.selectedOikeusKayttaja = this.$user;
    this.getUserObjects();

    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
  watch: {
    selectedOikeusKayttaja() {
      this.getUserObjects();
    },
    vuosi() {
      this.getUserObjects();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>